import React from "react";
import { howItWorksSteps } from "../../data/mock";
import { ClipboardList, Cpu, FileCheck } from "lucide-react";

const stepIcons = [ClipboardList, Cpu, FileCheck];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 px-4 bg-slate-950">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-emerald-400 text-sm font-semibold tracking-wider uppercase">
            How It Works
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-4 mb-4">
            From Zero to Strategy in Minutes
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto">
            No consultants, no weeks of waiting. Just powerful AI analyzing your market.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8">
          {howItWorksSteps.map((step, index) => {
            const IconComponent = stepIcons[index];
            return (
              <div
                key={step.step}
                className="relative bg-slate-900/50 border border-slate-800 rounded-2xl p-8 hover:border-emerald-500/50 transition-all duration-300 group"
              >
                {/* Step number */}
                <div className="absolute -top-4 left-8 bg-emerald-500 text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm">
                  {step.step}
                </div>
                
                {/* Icon */}
                <div className="w-14 h-14 bg-emerald-500/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-emerald-500/20 transition-colors">
                  <IconComponent className="w-7 h-7 text-emerald-400" />
                </div>
                
                <h3 className="text-xl font-semibold text-white mb-3">
                  {step.title}
                </h3>
                <p className="text-slate-400 leading-relaxed">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Connection line REMOVED */}
      </div>
    </section>
  );
};

export default HowItWorks;
